import { Text } from '@chakra-ui/react';
import { Listing } from 'src/api/v1-api';
import { calculateTimeSince } from 'src/utils/timeUtils';

interface LastUpdatedProps {
  listing: Listing;
}

const LastUpdated = ({ listing }: LastUpdatedProps): JSX.Element => {
  if (listing?.updated_at && listing?.category?.functional?.show_last_updated) {
    const timeSinceUpdated = calculateTimeSince(listing.updated_at);
    return (
      <Text fontSize="0.7rem" color="gray.600">
        Last updated {timeSinceUpdated}
      </Text>
    );
  }
  return <></>;
};

export default LastUpdated;
